export * from './PermissionsPrimerLocationView';
